import { Breadcrumbs, Link, Tooltip, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import FormContainer from "../../../../../common/components/form_container"
import AlertError from "../../../../../common/components/alert_error"
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input"
import { BackButton } from "../../../../../common/components/back_button"
import BottomBar from "../../../../../common/components/bottom_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import DefaultFormInput from "../../../../../common/components/default_form_input"
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input"
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo"
import { DropDownCliente } from "../../../../../common/components/dropdown_cliente"
import { Link as LinkTo } from 'react-router';
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { useFinanceiroContratoCadastroViewModel } from "../../viewModels/financeiro_contratos_cadastro_view_model"
import { DropDownFornecedor } from "../../../../../common/components/dropdown_fornecedor"
import { FormPercentageMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_percentage_masked_input"
import { DropDownUnidade } from "../../../../../common/components/dropdown_unidade"
import { TabelaPgtoContrato } from "./components/tabelaPgtosContrato"
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete"
import { ConfigurarPgtosModal } from "./components/cadastro_pagamentos_contrato"
import { CadastroInformacaoPgtoModal } from "./components/cadastro_informacao_pagamento"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import { LogReajusteContratoFinanceiroModal } from "./components/log_reajuste_contrato_financeiro_modal"
import { DefaultFormMoneyInput } from "../../../../../common/components/default_form_money_input"
import { UpdateMotivoModal } from "./components/update_motivo_modal"
import { CadastroReajusteIndividualModal } from "./components/cadastro_reajuste_individual"
import { LogContratoFinanceiroDetalhadoModal } from "./components/log_contrato_financeiro_detalhado_modal"
import { CadastroJurosMultaContratoModal } from "./components/cadastro_juros_multa_contrato"


export const FinanceiroContratosCadastro = () => {
    const viewModel = useFinanceiroContratoCadastroViewModel();

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row w-full justify-end gap-2" >
                            <BackButton
                                onClick={() => viewModel.handlePageBack()} />
                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="primary-green"
                                    onClick={() => viewModel.handleContratoFinanceiroRelatorioIndividual()}>
                                    Relatório
                                </PrimaryButton>
                            </div>
                            {
                                viewModel.contratoFinanceiro && viewModel.contratoFinanceiro.status === 0 &&
                                <div className="w-[12rem]">
                                    <PrimaryButton
                                        buttonColor="yellow"
                                        onClick={() => viewModel.handleParalisarContrato()}>
                                        Paralisar Contrato
                                    </PrimaryButton>
                                </div>
                            }
                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="red"
                                    onClick={() => viewModel.handleCancelarContratoOpenState(true)}>
                                    Cancelar Contrato
                                </PrimaryButton>
                            </div>

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleDeleteInformacaoOpenState(null, true)}>
                                    Excluir Selecionados
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>
            <form onSubmit={viewModel.handleSalvarContrato}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Financeiro
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to='/ContratoFinanceiros_lista'>Contrato financeiro Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Cadastro Contrato Financeiro
                        </Typography>
                    </Breadcrumbs>

                    <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white"> Contrato Financeiro</h1>
                            <RefreshButton onClick={() => { }} />
                        </div>

                        <div className="w-full justify-end flex gap-2">

                        </div>
                    </div>
                    {
                        "" === undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={""}
                                    onTryAgain={() => { }} />
                            </div>
                        ) : (
                            <>
                            </>
                        )
                    }
                    <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
                        <FormContainer title='Informações Contrato' arrangement='fullRow' border={false}>
                            <div className="flex flex-col items-center w-full gap-4">
                                <div className="flex justify-start mr-5 w-full">
                                    <div className="flex flex-col items-center w-full gap-2">
                                        <div className="grid grid-cols-1 gap-5 w-full justify-between">
                                            <FormRadioGroupInput
                                                name='status'
                                                label='Status'
                                                readOnly={true}
                                                options={[
                                                    { id: 0, label: 'Em Andamento' },
                                                    { id: 1, label: 'Finalizado' },
                                                    { id: 2, label: 'Cancelado' },
                                                    { id: 3, label: 'Paralisado' },
                                                ]}
                                                reactHookForm={viewModel.hookFormContrato}
                                            />
                                        </div>

                                        <div className="flex flex-row gap-4 w-full justify-between">
                                            <div className="w-[20%]">
                                                <DefaultFormInput
                                                    name='idContratoFinanceiro'
                                                    label='Código'
                                                    required={false}
                                                    readOnly={true}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>

                                            <div className="w-[80%]">
                                                <DefaultFormInput
                                                    name='descricao'
                                                    label='Descricao'
                                                    required={false}
                                                    readOnly={false}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>

                                        </div>
                                        <div className="flex flex-row gap-4 w-full">
                                            <div className="w-1/3">
                                                <DropDownCentroCusto
                                                    name="idCentroCusto"
                                                    label="Centro de Custo"
                                                    required={true}
                                                    readOnly={viewModel.statusContrato}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                            {
                                                viewModel.selectedIdCentroCusto &&
                                                <>
                                                    <div className="w-1/3">
                                                        <DropDownCliente
                                                            name="idCliente"
                                                            label="Nome do Cliente"
                                                            required={false}
                                                            readOnly={viewModel.statusContrato}
                                                            reactHookForm={viewModel.hookFormContrato}
                                                            idCentroCusto={viewModel.selectedIdCentroCusto}
                                                        />
                                                    </div>

                                                    <div className="w-1/3">
                                                        <DropDownUnidade
                                                            name="idClienteCentroCusto"
                                                            idCliente={viewModel.idClienteUnidade ?? null}
                                                            idCentroCusto={null}
                                                            label="Unidade"
                                                            required={false}
                                                            readOnly={viewModel.statusContrato}
                                                            reactHookForm={viewModel.hookFormContrato}
                                                        />
                                                    </div>
                                                </>
                                            }


                                        </div>

                                        <div className="grid grid-cols-3 gap-4 w-full justify-between">
                                            <div className="flex flex-row items-center gap-1">
                                                <Tooltip
                                                    title="Esse é o valor total da unidade, considerando valor financiado com a construtora + valor financiado com o banco"
                                                    slotProps={{ tooltip: { sx: { fontSize: '0.90rem' } } }}
                                                >
                                                    <div className="flex items-center justify-center w-7 h-7 bg-blue-500 rounded-full text-white text-sm font-bold cursor-help">
                                                        ?
                                                    </div>
                                                </Tooltip>
                                                <DefaultFormMoneyInput
                                                    name='valorGlobal'
                                                    label='Valor Global do Contrato'
                                                    required={false}
                                                    readOnly={false}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>

                                            <DefaultFormMoneyInput
                                                name='valorTotal'
                                                label='Valor Financiado com a construtora'
                                                required={true}
                                                readOnly={viewModel.statusContrato}
                                                reactHookForm={viewModel.hookFormContrato}
                                            />

                                            <DefaultFormMoneyInput
                                                name='valorFinanciadoBanco'
                                                label='Valor Financiado com o Banco'
                                                required={false}
                                                readOnly={false}
                                                reactHookForm={viewModel.hookFormContrato}
                                            />

                                        </div>

                                        <div className="flex flex-row gap-4 w-full justify-between">
                                            <div className="w-[40%]">
                                                <FormDatePickerInput
                                                    name='dataInicio'
                                                    label='Data de Inicio Contrato'
                                                    required={true}
                                                    readOnly={viewModel.statusContrato}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                            <div className="w-[40%]">
                                                <FormDatePickerInput
                                                    name='dataInicialReajuste'
                                                    label='Data Inicial de aplicação do reajuste'
                                                    required={false}
                                                    readOnly={viewModel.statusContrato}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                            <div className="w-[30%]">
                                                <FormPercentageMaskedInput
                                                    name='percentualJuros'
                                                    label='Percentual Juros'
                                                    required={false}
                                                    readOnly={viewModel.statusContrato}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                            <div className="w-[30%]">
                                                <DefaultFormMoneyInput
                                                    name='valorSaldoDevedor'
                                                    label='Saldo Devedor'
                                                    required={false}
                                                    readOnly={true}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex flex-row gap-4 w-full justify-between">
                                            <div className="w-[40%]">
                                                <DefaultFormAutocomplete
                                                    name="idIndiceReajuste"
                                                    label="Indice de Reajuste"
                                                    required={true}
                                                    readOnly={viewModel.statusContrato}
                                                    options={viewModel.ddlIndiceReajuste ?? []}
                                                    getOptionLabel={x => x.title}
                                                    getOptionKey={x => x.id}
                                                    reactHookForm={viewModel.hookFormContrato} />
                                            </div>
                                            <div className="w-[40%]">

                                                <DropDownFornecedor
                                                    name="idFornecedor"
                                                    label="Nome do Corretor"
                                                    required={false}
                                                    readOnly={viewModel.saving}
                                                    reactHookForm={viewModel.hookFormContrato}
                                                />
                                            </div>
                                            <div className="w-[20%]">

                                                <DefaultFormMoneyInput
                                                    name='valorComissao'
                                                    label='Valor Comissão Corretor'
                                                    required={false}
                                                    readOnly={viewModel.statusContrato}
                                                    reactHookForm={viewModel.hookFormContrato}

                                                />

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </FormContainer>
                    </div>
                </div >

                <BottomBar>
                    <div className="w-full h-full items-center justify-between flex p-4">
                        <div>
                            {
                                viewModel.contratoFinanceiro &&
                                <>
                                    <div className="flex flex-row gap-2">
                                        <PrimaryButton
                                            buttonColor="yellow"
                                            onClick={() => viewModel.handleOpenChangeHistory(viewModel.contratoFinanceiro?.idContratoFinanceiro ?? null, null)}>
                                            <span className="text-xs">
                                                Historico de alterações
                                            </span>
                                        </PrimaryButton>

                                        <PrimaryButton
                                            buttonColor="orange"
                                            onClick={() => viewModel.handleLogReajusteContratoOpenState(true)}>
                                            <span className="text-xs">
                                                Historico de Reajustes no contrato
                                            </span>
                                        </PrimaryButton>


                                        <PrimaryButton
                                            buttonColor="orange"
                                            onClick={() => viewModel.handleLogContratoFinanceiroDetalhadoOpenState(true)}>
                                            <span className="text-xs">
                                                Historico de Contrato Detalhado
                                            </span>
                                        </PrimaryButton>

                                    </div>
                                </>
                            }
                        </div>

                        <div className="flex flex-row gap-6 w-full justify-end">
                            {
                                viewModel.contratoFinanceiro &&
                                <div className="">
                                    <PrimaryButton
                                        onClick={() => viewModel.handleReajusteIndividualOpenState(true)}
                                        buttonColor="orange" >
                                        Configurar Reajustes
                                    </PrimaryButton>
                                </div>
                            }

                            {
                                (viewModel.statusContrato && viewModel.contratoFinanceiro?.status === 0) &&
                                <div className="">
                                    <PrimaryButton
                                        onClick={() => viewModel.handleFinalizarContrato()}
                                        buttonColor="blue" >
                                        Finalizar Contrato
                                    </PrimaryButton>
                                </div>
                            }
                            {
                                !viewModel.statusContrato && viewModel.contratoFinanceiro &&
                                <>
                                    <div className="">
                                        <PrimaryButton
                                            onClick={() => viewModel.handleConfigurarMultaJurosModal(true)}
                                            buttonColor="secondary" >
                                            Configurar Multa e Juros
                                        </PrimaryButton>
                                    </div>

                                    <div className="">
                                        <PrimaryButton
                                            onClick={() => viewModel.handleConfigurarPgtoModal(true)}
                                            buttonColor="purple" >
                                            Configurar Pagamento
                                        </PrimaryButton>
                                    </div>
                                </>

                            }
                            {
                                !viewModel.statusContrato && viewModel.contratoFinanceiro &&
                                <div className="">
                                    <PrimaryButton
                                        onClick={() => viewModel.handleIniciarPagamento()}
                                        buttonColor="primary-green" >
                                        Iniciar Pagamento
                                    </PrimaryButton>
                                </div>
                            }

                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1
                                    className="text-sm text-black dark:text-white"
                                    onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving
                                    ? (
                                        <PrimaryButton>
                                            Salvando...
                                        </PrimaryButton>
                                    ) : (
                                        !viewModel.contratoFinanceiro ?
                                            <PrimaryButton
                                                type="submit"
                                                startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                                                Salvar
                                            </PrimaryButton>
                                            :
                                            <PrimaryButton
                                                type="button"
                                                onClick={() => viewModel.handleUpdateMotivoModal(true)}
                                                startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                                                Salvar
                                            </PrimaryButton>

                                    )}
                            </div>

                        </div>
                    </div>
                </BottomBar>
            </form >

            <div className="flex w-full mb-24 gap-6 flex-col md:px-10 ">
                <TabelaPgtoContrato
                    loading={viewModel.loading}
                    pgtoContratoLista={viewModel.pgtoContratoLista ?? []}
                    page={viewModel.pagination.page}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    totalItems={viewModel.pagination.totalItems}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    handlePgtoCadastroOpenState={viewModel.handleOpenInformacaoPgtoModal}
                    handlePgtoDeleteOpenState={viewModel.handleDeleteInformacaoOpenState}
                    valoresFooter={viewModel.valoresFooter}

                    handleRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                    handlePageChange={viewModel.handlePageChange}
                    handleRowsPerPageChange={viewModel.handleRowsPerPageChange}
                />
            </div>


            {/*  */}
            < DeleteDialog
                open={viewModel.openDeleteContratoModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleContratoDeleteOpenState(false)}
                title={`Você realmente deseja excluir o contrato?`}
                onDelete={viewModel.handleDeleteContrato}

            />

            {/*  */}
            < DeleteDialog
                open={viewModel.openDeletePgtoModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleDeleteInformacaoOpenState(null, false)}
                title={`Você realmente deseja excluir o Pagamento?`}
                onDelete={viewModel.handleConfirmDeletePgto}

            />

            {/* componente modificado para efetuar cancelamento */}
            < DeleteDialog
                open={viewModel.openCancelarContratoModal}
                saving={viewModel.saving}
                windowTitle="Cancelamento de Contrato"
                buttonTitle="Enviar"
                onClose={() => viewModel.handleCancelarContratoOpenState(false)}
                title={`O cancelamento do contrato irá afetar os registros vinculados,
                    Você realmente deseja cancelar o contrato?`}
                onDelete={viewModel.handleCancelarContrato}
            />

            <CadastroInformacaoPgtoModal
                open={viewModel.openInfoPgtosModal}
                saving={viewModel.saving}
                pgtoContrato={viewModel.pgtoContrato}
                onSubmit={viewModel.handleSubmitInformacaoPgto}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onClose={() => viewModel.handleOpenInformacaoPgtoModal(null, false)}

            />

            <ConfigurarPgtosModal
                open={viewModel.openConfigurarPgtoModal}
                saving={viewModel.saving}
                onSubmit={viewModel.handleSubmitPgtosContrato}
                onClose={() => viewModel.handleConfigurarPgtoModal(false)}
                hookForm={viewModel.hookFormPgto}

                projetarMeses={viewModel.projetarMeses}
                pagamentoAvista={viewModel.pagamentoAvista}
                entrada={viewModel.entrada}
                dividirEntrada={viewModel.dividirEntrada}
                parcelaSecundaria={viewModel.parcelaSecundaria ?? false}

                valorFinanciado={viewModel.valorFinanciado}
                valorRestante={viewModel.valorRestante}
            />

            <LogReajusteContratoFinanceiroModal
                open={viewModel.openLogReajusteContratoModal}
                loading={viewModel.loading}
                logReajusteContratoFinanceiroLista={viewModel.logReajusteContratoFinanceiroLista ?? []}
                totalItems={viewModel.paginationLogReajuste.totalItems}
                page={viewModel.paginationLogReajuste.page}
                rowsPerPage={viewModel.paginationLogReajuste.rowsPerPage}
                handlePageChange={viewModel.handlePageChangeLogReajuste}
                handleRowsPerPageChange={viewModel.handleRowsPerPageChangeLogReajuste}
                onClose={() => viewModel.handleLogReajusteContratoOpenState(false)}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

            <ReportViewerModal
                reportViewerState={viewModel.reportViewerState}
            />

            <UpdateMotivoModal
                open={viewModel.openUpdateMotivoModal}
                saving={viewModel.saving}
                hookForm={viewModel.hookFormContrato}
                onSubmit={viewModel.handleSalvarContrato}
                onClose={() => viewModel.handleUpdateMotivoModal(false)}
            />

            <CadastroReajusteIndividualModal
                open={viewModel.openReajusteIndividualModal}
                saving={viewModel.saving}
                idContratoFinanceiro={viewModel.contratoFinanceiro?.idContratoFinanceiro ?? 0}
                idIndiceReajuste={viewModel.hookFormContrato.getValues('idIndiceReajuste') ?? 0}
                ddlIndiceReajuste={viewModel.ddlIndiceReajuste}
                onSubmit={viewModel.handleReajusteIndividualSubmit}
                onClose={() => viewModel.handleReajusteIndividualOpenState(false)}
            />

            <CadastroJurosMultaContratoModal
                open={viewModel.openConfigurarMultaJurosModal}
                saving={viewModel.saving}
                percentualJuros={viewModel.contratoFinanceiro?.jurosAtraso ?? 0}
                percentualMulta={viewModel.contratoFinanceiro?.multaAtraso ?? 0}
                idContratoFinanceiro={viewModel.contratoFinanceiro?.idContratoFinanceiro ?? 0}
                onSubmit={viewModel.handleSubmitJurosMultaContrato}
                onClose={() => viewModel.handleConfigurarMultaJurosModal(false)}
            />

            <LogContratoFinanceiroDetalhadoModal
                open={viewModel.openLogContratoFinanceiroDetalhadoModal}
                loading={viewModel.loading}
                logContratoFinanceiroDetalhadoLista={viewModel.logContratoFinanceiroDetalhadoLista ?? []}
                totalItems={viewModel.paginationLogDetalhado.totalItems}
                page={viewModel.paginationLogDetalhado.page}
                rowsPerPage={viewModel.paginationLogDetalhado.rowsPerPage}
                handlePageChange={viewModel.handlePageChangeLogContratoFinanceiroDetalhado}
                handleRowsPerPageChange={viewModel.handleRowsPerPageChangeLogContratoFinanceiroDetalhado}
                onClose={() => viewModel.handleLogContratoFinanceiroDetalhadoOpenState(false)}
            />

        </>
    )
}